// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-default,.layout-default>.container-fluid{display:flex;flex-direction:column}.layout-default>.container-fluid{flex-grow:1;padding-top:.75rem;padding-bottom:.75rem}@media (min-width:576px){.layout-default>.container-fluid{padding-top:1.5rem;padding-bottom:1.5rem}}.layout-default .page{width:100%;max-width:640px;margin:0 auto}.layout-default .page>*{margin-bottom:3rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
